import * as Yup from "yup";

export const ExpenseValidationSchema = Yup.object({
  amount: Yup.number()
    .positive("Amount must be greater than 0")
    .required("Amount is required"),
  category: Yup.object({
    id: Yup.mixed().required("Category is required"),
    name: Yup.string().required("Category is required"),
  }).required("Category is required"),
  date: Yup.string().required("Date is required."),
});
